import { createAction } from "redux-actions";

export const ROLE_LIST = "ROLE_LIST";
export const roleList = createAction(ROLE_LIST);

export const ROLE_DETAILS = "ROLE_DETAILS";
export const roleDetails = createAction(ROLE_DETAILS);

export const ADD_ROLE = "ADD_ROLE";
export const addRole = createAction(ADD_ROLE);

export const UPDATE_ROLE = "UPDATE_ROLE";
export const updateRole = createAction(UPDATE_ROLE);

export const DELETE_ROLE = "DELETE_ROLE";
export const deleteRole = createAction(DELETE_ROLE);
